<template>
  <div>
    <el-dialog @close='ge()'
      :visible.sync="linksVisible"
      width="600px"
      :title="ifsate == 1? '模式切换':ifsate == 2?'设置':'标签分组'">
      <div class="flexspan" style="border-top:1px solid #efefef"> 
        <span>币种</span>
        <span>{{data.coinType}}</span>
      </div>
      <div v-if="ifsate == 1">
        <div class="flexspan"> 
          <span>切换至</span>
          <span @click="getswitch()" style="cursor: pointer;">{{switchs=='模式二'?'模式一':'模式二'}}</span>
        </div>
        <div v-if="switchs == '模式一'" class="flexspan"> 
          <span>提现成本</span>
          <input type="text" placeholder="请输入提现成本" v-model="cost" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"/>
        </div>
        <div v-if="switchs == '模式一'" class="flexspan"> 
          <span>手续费精度</span>
          <input type="text" placeholder="请输入精度位数" v-model="precision" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'');if(value>14){value=14};if(String(value)<='0'){value=1}"/>
        </div>
        <div class="flexspan" v-else> 
          <span>提现手续费</span>
          <input type="text" placeholder="请输入提现手续费" v-model="WithdrawalFee" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,16})?/)[0] : ''"/>
        </div>
      </div>
      <div v-else-if="ifsate == 2">
        <div class="flexspan"> 
          <span>当前模式</span>
          <span>{{switchs}}</span>
        </div>
        <div v-if="data.withdrawFeeType == '模式二'" class="flexspan"> 
          <span>提现成本</span>
          <input type="text" placeholder="请输入提现成本" v-model="cost" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"/>
        </div>
        <div v-if="data.withdrawFeeType == '模式二'" class="flexspan"> 
          <span>手续费精度</span>
          <input type="text" placeholder="请输入精度位数" v-model="precision" onkeyup="value=value.replace(/[^0-9]/g,'');if(value>14){value=14};if(String(value)==='0'){value=1}" />
        </div>
        <div class="flexspan" v-else> 
          <span>提现手续费</span>
          <input type="text" placeholder="请输入提现手续费" v-model="WithdrawalFee" onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,16})?/)[0] : ''"/>
        </div>
      </div>
      <div class="flexspan" v-else> 
        <span>标签</span>
        <input type="text" v-model="inputlabel" placeholder="请输入标签" />
      </div>
      <button @click="submit">提交</button>
    </el-dialog>
  </div>
</template>
<script>
import "../store.js";
import Pagination from "../../../components/pagination";
import { mapState, mapActions } from "vuex";
import { SHARE_TYPE } from "../constant.js";
export default {
  name: "modeswitchs",
  data() {
    return {
      switchs:'模式二',
      modeswitch:true,
      linksVisible:false,

      paginations: {
        page: 1,
        size: 10
      },
      coninname:'',
      ifsate:1,
      data:{},
      WithdrawalFee:null,
      withdrawFeeType:null,
      cost:null,
      precision:null,
      inputlabel:'',
    };
  },
  computed: {
    ...mapState('withdrawal', ['pagination']),
  },
  created(){
    // this.updateWithdraw()
    
  },
  methods: {
    checkInt(n,max){
    var regex = /^\d+$/;
    if(regex.test(n)){
       if(n<max && n>0){
          alert("这是小于"+max+"的正整数！！")
       }else{
          alert("这不是小于"+max+"的正整数！！")
       }
    }else{
       alert("非整数");
    }
},
    ge(){
      this.WithdrawalFee=null;
      this.cost=null;
      this.precision=null
    },
    ...mapActions('withdrawal', ['updateWithdraw','getCoinWithdrawFeeConfigList','remove']),
    submit(){
      let obj = this.data;
      console.log(obj.withdrawFeeType)
      let modeswit = obj.withdrawFeeType == '模式二'?{
        withdrawFee:this.WithdrawalFee
      }:{
        cost:this.cost,
        costPrecision:this.precision
      }
      let tran = {
        id:obj.id,
        updateType:0,
        withdrawFeeType:this.switchs=='模式一'?1:0,
        ...modeswit
      }
      let setting = obj.withdrawFeeType == '模式一'?{
        withdrawFee:this.WithdrawalFee
      }:{
        cost:this.cost,
        costPrecision:this.precision
      }
      let set = {
        id:obj.id,
        updateType:0,
        withdrawFeeType:this.switchs=='模式一'?0:1,
        ...setting
      }
      let label = {
        id:obj.id,
        updateType:1,
        groupName:this.inputlabel
      }
      if(this.ifsate == 1){
        this.updateWithdraw(tran);
        console.log(1)
      }else if(this.ifsate == 2){
        this.updateWithdraw(set)
      }else{
        this.updateWithdraw(label)
      }
     
      this.getList()
      this.getList()
      this.linksVisible = false;
    },
  getList(){
    this.getCoinWithdrawFeeConfigList({
      ...this.paginations,
      coinType:''
    });
  },
  getswitch(){
    if(this.switchs == '模式二'){
      this.switchs = '模式一'
    }else{
      this.switchs = '模式二'
    }
    
  },
  showData(data,state,paginations) {
    this.paginations = paginations;
    this.data = data;
    this.ifsate = state;
    this.linksVisible = true;
    this.switchs = data.withdrawFeeType
    this.inputlabel = data.groupName
  },
   
  },
  filters: {
    
  },
  components: {
    Pagination
  }
};
</script>
<style lang="less" scoped>
.el-icon-edit {
  color: #409eff;
  cursor: pointer;
}

.el-dialog__body{
  .flexspan{
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
    color: #303133;
    
  }
  button{
    width: 100%;
    height: 50px;
    text-align: center;
    background: #466fe1;
    color: white;
    font-size: 16px;
    cursor: pointer;
    margin-top: 30px;
  }
}
input,button{
  border: none;
  list-style: none;
  outline: none;
  text-align: right;
}
</style>
